<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-mouse-follower></app-mouse-follower>



